<div class="title">
  <mat-icon>event</mat-icon>
  Month
</div>
<div class="description">SELECT THE MONTH TO FILTER BY</div>

<div class="options">
  @for (month of allMonths; track month) {
    <elements-filter-chip
      icon="event"
      [caption]="getDisplayName(month)"
      [selected]="isSelected(month)"
      (click)="isSelected(month) ? removeProduct(month) : addProduct(month)"
      >
    </elements-filter-chip>
  }
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
